import { render, staticRenderFns } from "./fullGiftList.vue?vue&type=template&id=3d64e3f8&scoped=true&"
import script from "./fullGiftList.vue?vue&type=script&lang=ts&"
export * from "./fullGiftList.vue?vue&type=script&lang=ts&"
import style0 from "./fullGiftList.vue?vue&type=style&index=0&id=3d64e3f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64e3f8",
  null
  
)

export default component.exports